import { Heading, Text } from '@ox-technologies/ui';
import { cn } from '@ox-technologies/utils';

type LayoutHeadingsProps = {
  heading: string;
  subHeading: string;
  isLoginScreen: boolean;
};

/**
 * Welcome heading + subheading on the branded navy panel.
 *
 * The soft dark "shadow" blob behind the headings is always shown on
 * non-login screens; on the login screen it only shows below the `md`
 * breakpoint (where the box illustration is hidden) — same rule the old
 * JS viewport check implemented.
 */
const LayoutHeadings = ({
  heading,
  subHeading,
  isLoginScreen,
}: LayoutHeadingsProps) => {
  return (
    <div
      className={cn(
        'relative max-w-full text-center',
        isLoginScreen ? 'max-md:mb-[-5%]' : 'mb-[-5%]'
      )}
    >
      <Heading
        as="h1"
        level={1}
        className="font-ox-display text-[40px] font-normal leading-[44px] tracking-[-0.8px] text-ox-on-ink"
      >
        {heading}
      </Heading>
      <Text className="mt-[16px] text-[18px] leading-[1.65] text-ox-on-ink-2 max-md:mt-0">
        {subHeading}
      </Text>
      <div
        aria-hidden
        className={cn(
          'absolute left-1/2 top-[65%] z-[-1] h-[110px] w-[368px] -translate-x-1/2 bg-primary-950 blur-[38px]',
          isLoginScreen && 'md:hidden'
        )}
      />
    </div>
  );
};

export default LayoutHeadings;
